/**
* 基础菜单 绑定打印机
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <!-- <el-button size="small" type="primary" @click="search">查询</el-button> -->
        <el-button size="small" type="success" @click="addStoreDialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editStoreDialog" class="edit-button">修改</el-button>
        <!-- <el-button size="small" type="danger" @click="delStore">删除</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}" :span-method="objectSpanMethod"
                element-loading-text="拼命加载中" style="width: 70%;">
        <el-table-column align="center" type="selection" prop="selection" width="60" >
        </el-table-column>
        <el-table-column
          label="序号"
          prop="Nosort"
          width="60">
            <!-- <template slot-scope="scope"> -->
            <!--   {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}} -->
            <!-- </template> -->
        </el-table-column>
        <el-table-column prop="siid" label="打印机设备码" min-width="370" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="name" label="物流公司" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="template_code" label="打印模版" width="370" :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="storeDialogVisible"
               width="34%"
               :before-close="handleClose"
               center>
      <div class="fs16 color409EFF mb10">打印机信息</div>
      <el-form :model="flashForm" :rules="rules" ref="flashForm" label-width="155px" class="flashForm">
        <el-form-item label="打印机设备码" prop="siid" class="relative">
          <el-input v-model="flashForm.siid" clearable maxlength="45" placeholder="请输入打印机设备码">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="scrollbar mt20" style="max-height: 380px;overflow-y: auto">
          <p class="f16 color409EFF fw600 mb10">打印机模板信息</p>
          <el-table size="small" :data="printerData" highlight-current-row v-loading="loading" border
                    element-loading-text="拼命加载中" style="width: 100%;margin-bottom: 20px">
            <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
            <el-table-column prop="delivery_company_id" label="物流公司" min-width="175">
              <template slot-scope="scope" style="position: relative">
                <el-select v-model="scope.row.delivery_company_id" filterable placeholder="请选择物流公司" clearable @click="getCompany()"
                           :class="productcodeIndexList.indexOf(scope.$index)>-1?'redBorder':''">
                  <el-option
                    v-for="item in companyDeliveryListData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="template_code" label="打印模版" width="175" :show-overflow-tooltip='true'>
              <template slot-scope="scope" style="position: relative">
                  <el-input v-model="scope.row.template_code"  placeholder="打印模版" maxLength="100" clearable
                            :class="modelIndexList.indexOf(scope.$index)>-1?'redBorder':''">
                  </el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="157">
              <template slot-scope="scope">
                <el-button type="danger" plain size="mini" @click.native.prevent="deleteRow(scope.$index, printerData)"
                           style="width: 80px">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="stions"><el-button type="primary" size="medium" plain @click="addSpecifications">新增打印模板</el-button></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSort('flashForm')">确 认</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  printerList,
  printerAdd, popularDeliveryList, printerUpdate, eorderDeliveryList
} from '../../api/basisMG'
  import {param, uploadVideo, uploadImgTmp, getToken} from '../../api/commonMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, uploadFile} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false,
        storeDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        status: true,
        voucherType: [],  // 优惠券类型
        productId: '',
        formInline: {
          page: 0,
          rows: 0,
        },
        flashForm: {
          id: '',
          siid: '',
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 0,
          pageSize: 0,
          total: 0
        },
        sale_id: '',
        // rules表单验证
        rules: {
          siid: [{required: true, message: '请输入打印机设备码', trigger: 'blur'}],
        },
        selectTableData: [],
        printerData: [],
        obj:{
          delivery_company_id: '',
          template_code: '',
        },
        companyDeliveryListData: [],
        delivery_company_id: '',
        template_code: '',
        index: true,
        spanArr: [], // 存合并行数据的数组
        three: [],
        productcodeIndexList: [],
        modelIndexList: [],
        showRedBorder:false,
        scope: '',
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 处理要合并相同行的列
      getSpanArr(data) {
        this.multipleChoiceArr = []
        this.spanCreateTimeArr = []
        this.SerialNumberArr = []
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanCreateTimeArr.push(1)
            this.multipleChoiceArr.push(1)
            this.SerialNumberArr.push(1)
            this.timepos = 0
            this.pos = 0
            this.codePos = 0
          } else {
            // 选项
            if (data[i].selection === data[i - 1].selection && data[i].siid === data[i - 1].siid) {
              this.spanCreateTimeArr[this.timepos] += 1
              this.spanCreateTimeArr.push(0)
            } else {
              this.spanCreateTimeArr.push(1)
              this.timepos = i
            }
            // 序号
            if (data[i].siid === data[i - 1].siid) {
              this.multipleChoiceArr[this.pos] += 1
              this.multipleChoiceArr.push(0)
            } else {
              this.multipleChoiceArr.push(1)
              this.pos = i
            }
            // 打印机设备码
            if (data[i].siid === data[i - 1].siid) {
              this.SerialNumberArr[this.codePos] += 1
              this.SerialNumberArr.push(0)
            } else {
              this.SerialNumberArr.push(1)
              this.codePos = i
            }
          }
        }
        // 表格序号
        let Nosort = 0;
        for(let n in this.spanCreateTimeArr){
            if(this.spanCreateTimeArr[n]>0){
                Nosort += 1;
                this.$set(this.listData[n],'Nosort',Nosort) // this.list为最后展示的数组
            }
        }
      },
      getTypeAndUserByHalfYear(param){
          getTypeAndUserByHalfYear(param).then(
              (resp)=>{
                  this.listData = resp.body;
                  for (let i = 0; i < this.listData.length; i++){
                      let siid = this.judgeType(this.listData[i].type);
                      this.list[i].siid = siid;
                  }
                  this.getSpanArr(this.listData);
              }
          )
          //.catch(
          //   (resp)=>{
          //       this.$message.error("统计出错！")
          //   }
          //)
      },
      objectSpanMethod({row, column, rowIndex, columnIndex}) {
         if(this.listData.length > 0 ){
          // 选项
          if (columnIndex == 0) {
            const _row = this.spanCreateTimeArr[rowIndex]
            const _col = _row > 0 ? 1 : 0
            return {
              rowspan: _row,
              colspan: _col
            }
          }
          // 序号
          if (columnIndex == 1) {
            const _row = this.multipleChoiceArr[rowIndex]
            const _col = _row > 0 ? 1 : 0
            return {
              rowspan: _row,
              colspan: _col
            }
          }
          // 打印机设备码
          if (columnIndex == 2) {
            const _row = this.SerialNumberArr[rowIndex]
            const _col = _row > 0 ? 1 : 0
            return {
              rowspan: _row,
              colspan: _col
            }
          }
        }
      },
      // 列表
      getdata(parameter) {
        this.loading = true
        printerList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.page
              // this.pageparm.pageSize = this.formInline.rows
              // this.pageparm.total = res.content.total
              this.getSpanArr(this.listData)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      // callFather(parm) {
      //   this.formInline.page = parm.currentPage
      //   this.formInline.rows = parm.pageSize
      //   this.getdata(this.formInline)
      // },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.storeDialogVisible = false;
      },
      // 新增电子面单打印机
      addStoreDialog() {
        this.storeDialogVisible = true;
        this.dialogTitle = '新增电子面单打印机';
        this.flashForm = {};
        this.printerData = [];
        this.getCompany();
      },
      getCompany() {
        let data = {
          page: 0,
          rows: 10,
          name: "",
        }
        eorderDeliveryList(data)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
                if(res.content) {
                 this.companyDeliveryListData = res.content;
                }
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      addSpecifications(){
        this.printerData.push(JSON.parse(JSON.stringify(this.obj)))
      },
      // 修改电子面单打印机
      editStoreDialog(parameter) {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        for(let n in this.listData){
          if(this.listData[n].siid == this.selectTableData[0].siid) {
            this.three.push(this.listData[n])
          }
        }
        this.productId = this.selectTableData[0].id;
        this.storeDialogVisible = true;
        this.dialogTitle = '修改电子面单打印机';
        this.printerData = [];
        this.flashForm.siid = this.selectTableData[0].siid;
        this.getCompany();
        for(let i in this.three){
          this.printerData.push(JSON.parse(JSON.stringify(this.three[i])))
        }
        this.three = [];
      },
      deleteRow(index, rows) {
        const title = '删除后物流公司和打印模板都将被删除！';
        this.$confirm(title, '是否确认删除电子打印机！', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          rows.splice(index, 1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 确认-电子面单打印机
      saveSort() {
        let parameter = {

        }
        parameter.userDelieryPrinterAddReq = this.flashForm;
        parameter.userPrinterTemplateAddReqs = this.printerData;
        this.productcodeIndexList = [];
        this.modelIndexList = [];
        parameter.userPrinterTemplateAddReqs = this.printerData;
        this.loading = true;
        if (this.dialogTitle == '新增电子面单打印机') {
          printerAdd(parameter)
            .then(res => {
              this.loading = false
              if(res.content) {
                res.content.forEach((item)=>{
                  if(item.type=='delivery_company_id') {
                    this.productcodeIndexList.push(item.index-1)
                  }
                  if(item.type=='template_code') {
                    this.modelIndexList.push(item.index-1)
                  }
                })
              }
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功新增电子面单打印机'
                });
                this.storeDialogVisible = false;
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误,请稍后再试!')
            })
        } else {
          let parameter = {

          }
          parameter.userDelieryPrinterAddReq = this.flashForm;
          parameter.userPrinterTemplateAddReqs = this.printerData;
          this.flashForm.id = this.selectTableData[0].id;
          this.loading = true;
          printerUpdate(parameter)
            .then(res => {
              this.loading = false
              if(res.content) {
                res.content.forEach((item)=>{
                  if(item.type=='delivery_company_id') {
                    this.productcodeIndexList.push(item.index-1)
                  }
                  if(item.type=='template_code') {
                    this.modelIndexList.push(item.index-1)
                  }
                })
              }
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功修改电子面单打印机'
                });
                this.storeDialogVisible = false;
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error('网络错误,请稍后再试!')
            })
        }
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.siid == cell.innerText || row.delivery_company_id == cell.innerText || row.template_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .fs16 {
    font-size: 16px;
  }

  .color409EFF {
    color: #409EFF;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  .stions {
    border-bottom: 1px solid #ebeef5;
    padding: 8px 2px;
    text-align: center;
  }

  /deep/ .redBorder select{
    border-color: #F56C6C;
  }

  /deep/ .redBorder input{
    border-color: #F56C6C;
  }

  /deep/.modal {  z-index: -1;}

  .scrollbar::-webkit-scrollbar {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/views/store/storePrinter.vue